module.exports = __webpack_public_path__ + "img/smrz-s.37dbf869.png";